import HotelResultsController from './hotel-results-controller';
import HotelsListController from './controllers/hotels-list-controller';
import HotelsMapController from './controllers/hotels-map-controller';
import HotelsHeaderController from './controllers/hotels-header-controller';
import HotelDetailsController from './details/hotel-details-controller';
import HotelSearchFormController from './controllers/hotelSearchForm';
import HotelViewHeaderController from './controllers/hotelViewHeaderCtrl';
import HotelViewMapController from './controllers/hotelViewMapCtrl';
import HotelFiltersController from './controllers/hotelFiltersController';

import templateMainHotels from './templates/hotelForm.tmpl.html';
import templateMainHotelDetails from './templates/hotel-details.html';
import templateMainHotelsHeader from './templates/view_header.tmpl.html';
import templateHotelDetailsMap from './../base/templates/hotel_details_map.tmpl.html';
import templateMainHotelsTripAdvisor from './templates/view_tripadvisor.tmpl.html';
import templateMainHotelsResults from './templates/hotel-results.html';
import templateMainHotelsListHeader from './templates/hotel-list-header.html';
import templateMainHotelsFilters from './templates/hotel-list-filters.html';
import templateMainHotelsMapResults from './templates/hotel-map.html';
import templateMainHotelsList from './templates/hotel-list.html';

export const hotelStates = {
    MAIN: 'main.hotels',
    MAIN_VIEW: 'main.hotels.view',
    HOTEL_RESULTS: 'main.hotels.results',
};

export default function($stateProvider) {
    'ngInject';
    $stateProvider

        .state(hotelStates.MAIN, {
            url: '/hotels',
            views: {
                '': {
                    template: templateMainHotels,
                    controller: HotelSearchFormController,
                    controllerAs: 'hotelSearchFormCtrl',
                },
            },
            onEnter: ['$rootScope', function($rootScope) {
                $rootScope.pageHeading = 'Hotels search';
            }],
        })

        .state(hotelStates.MAIN_VIEW, {
            url: '/view/:hotelId?' + [
                'searchId',
                '{checkInDate:customDate}',
                '{checkOutDate:customDate}',
                'roomsQuantity',
                'occupantsQuantity',
                'searchTotal',
                'searchMinPrice',
                'searchMaxPrice',
                'centerLatitude',
                'centerLongitude',
                'altAddress',
            ].join('&'),
            resolve: {
                hotelDetails: ['$stateParams', 'hotelsAPI',
                    function($stateParams, hotelsAPI) {
                        return hotelsAPI.fetchHotelDetails($stateParams);
                    },
                ],
            },
            views: {
                '@main': {
                    template: templateMainHotelDetails,
                    controller: HotelDetailsController,
                },
                [`viewHeader@${hotelStates.MAIN_VIEW}`]: {
                    template: templateMainHotelsHeader,
                    controller: HotelViewHeaderController,
                },
                [`viewMap@${hotelStates.MAIN_VIEW}`]: {
                    template: templateHotelDetailsMap,
                    controller: HotelViewMapController,
                },
                [`viewTripAdvisor@${hotelStates.MAIN_VIEW}`]: {
                    template: templateMainHotelsTripAdvisor,
                },
            },
        })

        .state(hotelStates.HOTEL_RESULTS, {
            url: '/results?' + [
                'latitude',
                'longitude',
                'radius',
                '{checkInDate:customDate}',
                '{checkOutDate:customDate}',
                'roomsQuantity',
                'occupantsQuantity',
                'max',
                'min',
                'hotelName',
                'cityName',
                'Location',
                'administrativeAreaLevel1',
                'countryCode',
                'placeId',
                'Radius',
                'AmenitiesFilter',
                'MainAmenityFilter',
                'MaximumRadius',
                'MaximumTotalPriceFilter',
                'MinimumTotalPriceFilter',
                'PaymentTypeFilter',
                'StarRatingFilter',
                'RateFilter',
                'RefundableFilter',
            ].join('&'),
            onExit: ($rootScope) => {
                'ngInject';
                $rootScope.pageHeading = 'Hotels search';
            },
            resolve: {
                hotelSearchResults: function($stateParams, hotelsFactory) {
                    'ngInject';
                    return hotelsFactory.getHotels($stateParams);
                },
            },
            views: {
                '@main': {
                    template: templateMainHotelsResults,
                    controller: HotelResultsController,
                    controllerAs: 'hotelResultsCtrl',
                },
                [`resultsHeader@${hotelStates.HOTEL_RESULTS}`]: {
                    template: templateMainHotelsListHeader,
                    controller: HotelsHeaderController,
                    controllerAs: 'hotelsHeaderCtrl',
                },
                [`resultsFilters@${hotelStates.HOTEL_RESULTS}`]: {
                    template: templateMainHotelsFilters,
                    controller: HotelFiltersController,
                    controllerAs: 'hotelFiltersCtrl',
                },
                [`resultsMap@${hotelStates.HOTEL_RESULTS}`]: {
                    template: templateMainHotelsMapResults,
                    controller: HotelsMapController,
                    controllerAs: 'hotelsMapCtrl',
                },
                [`resultsHotels@${hotelStates.HOTEL_RESULTS}`]: {
                    template: templateMainHotelsList,
                    controller: HotelsListController,
                    controllerAs: 'hotelsListCtrl',
                },
            },
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotels-routes.js